export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12158.ed135bb8.jpg";